import React from "react";
import moment from "moment";
import { Badge, Box, Text, Stack } from "@chakra-ui/core";
import ActionList from "../dashboard/ActionList";
import getFormattedAmount from "../../helpers/formatAmount"

const Orders = ({ orders, refetch }) => {
  return orders.map((order, index) => {
    const {
      id,
      customerRef,
      customer,
      createdAt,
      amount,
      status,
      // currency,
    } = order;
    const date = moment.utc(parseInt(createdAt)).format("DD.MM.YYYY");  

    let variantColor = "";
    if (status === "paid") {
      variantColor = "success";
    } else if (status === "cancelled") {
      variantColor = "danger";
    } else if (status === "refunded") {
      variantColor = "warning";
    } else if (status === "processing") {
      variantColor = "gray";
    } else if (status === "pending") {
      variantColor = "blue";
    }

    return (
      <React.Fragment key={id} >
        <Box bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
          <Text fontWeight="bold" fontSize="md">{`${customer.firstName} ${customer.lastName}`}</Text>
          <Text fontSize="xs">{date}</Text>
        </Box>
        <Stack isInline alignItems="center" bg={index % 2 !== 0 ? "#fafafa" : "none"} height="auto">
          <Box fontSize="md">
          {getFormattedAmount(amount)}
          </Box>
        
        </Stack>
        <Stack isInline alignItems="center" bg={index % 2 !== 0 ? "#fafafa" : "none"} p="12px" height="auto">
    <Badge fontSize="1em" px={2} variantColor={variantColor}>{status}</Badge>
    {customerRef && <Text fontWeight="bold">/ {customerRef}</Text>}
    
        </Stack>
        <Stack
          bg={index % 2 !== 0 ? "#fafafa" : "none"}
          justifyContent="center"
          spacing={0}
        >
          <Stack isInline>
            <ActionList {... {order, refetch, status}} />
          </Stack>
        </Stack>
      </React.Fragment>
    );
  });
};

export default Orders;
